import { Component, inject, Input, OnInit } from '@angular/core';

import { ButtonComponent, FormSchemaComponent } from '@mds/ui';
import { isEqual } from 'lodash';
import { TeamSettingSection } from '@mds/common';
import { MakersiteService } from '@services/makersite.service';
import { ToastrService } from '@services/toaster.service';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-epd-settings',
  standalone: true,
  imports: [ButtonComponent, FormSchemaComponent, MatDialogModule],
  templateUrl: './epd-settings.component.html',
  styleUrls: ['./epd-settings.component.scss']
})
export class EpdSettingsComponent implements OnInit {
  @Input() teamRid!: string;
  @Input() section!: TeamSettingSection;
  public epdSectionSchema = null;
  public epdFormData = null;
  private makersiteService = inject(MakersiteService);
  private toastr = inject(ToastrService);

  ngOnInit(): void {
    this.epdSectionSchema = {
      ...this.section,
      // filter out company logo schema from formschema
      formSchema: this.section.formSchema
        .filter((field) => field.key !== 'epd_company_logo_url')
        .map((obj: any) => {
          obj.vertical = true;
          return obj;
        })
    };
  }

  epdFormValueChanged(ev) {
    if (!ev.valid) return;
    if (this.epdFormData && !isEqual(this.epdFormData, Object.values(ev.value)[0])) {
      // enable Update button when changed;
      this.epdSectionSchema.isUpdated = true;
    }
    [this.epdFormData] = Object.values(ev.value);
  }

  submitEpdForm() {
    if (!this.epdSectionSchema.isUpdated) {
      return;
    }
    this.updateSettings(this.epdFormData);
  }

  updateSettings(formData: any) {
    const payload = {
      key: this.teamRid,
      formData
    };
    this.makersiteService.updateTeamSetting(this.teamRid, payload).subscribe(() => {
      this.toastr.showMessage('Updated Successfully', 2000);
      if (this.epdSectionSchema?.isUpdated) {
        this.epdSectionSchema.isUpdated = false;
      }
    });
  }
}
